angular.module('impactx.catalogruleresult').controller('CatalogRuleDeliveryTimeListCtrl',
    CatalogRuleDeliveryTimeListCtrl);

CatalogRuleDeliveryTimeListCtrl.$inject = ['$routeParams'];

function CatalogRuleDeliveryTimeListCtrl($routeParams)
{
    this.meta = {
        rowTemplate: 'modules/catalogruleresult/templates/catalogruledeliverytimelist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/catalogruleresult/ruledeliverytimelist',
        id: "catalogruledeliverytimelist",
        params: {'cmrliId': $routeParams.id},
        excelParams: {
            params: [{param: 'CMRLIId', intValue: $routeParams.id}]
        },
        excelExport: true
    };
    this.getMeta = function () {
        return this.meta;
    }
}